import type { Mission } from '../missions.ts'

export const uscis: Mission = {
  id: "uscis",
  name: "U.S. Citizenship and Immigration Services",
  short: "USCIS",
  call: "Citizenship",
  kind: "subagency",
  parent: "dhs",
  url: "https://www.uscis.gov/",
  established: 2003,
  palette: {
    primary: "#002b47",
    secondary: "#c41230",
    accent: "#3293be",
  },
  colorSource: {
    kind: "seal",
    url: "https://commons.wikimedia.org/wiki/File:USCIS_Insignia.png",
  },
  motif: "torch",
  mission: {
    text: "USCIS was founded to enhance the security and efficiency of national immigration services by focusing exclusively on the administration of benefit applications.",
    url: "https://www.uscis.gov/about-us/our-history",
  },
  fact: {
    text: "On March 1, 2003, USCIS assumed responsibility for the immigration service functions of the federal government.",
    url: "https://www.uscis.gov/about-us/our-history",
  },
  seal: {
    file: "public/seals/uscis.png",
    source: "https://commons.wikimedia.org/wiki/File:USCIS_Insignia.png",
  },
  logo: {
    file: "public/logos/uscis.png",
    source: "https://commons.wikimedia.org/wiki/File:USCIS_Insignia.png",
  },
  identifier: {
    about: "https://www.uscis.gov/about-us",
    accessibility: "https://www.uscis.gov/website-policies/accessibility",
    foia: "https://www.uscis.gov/records/request-records-through-the-freedom-of-information-act-or-privacy-act",
    noFear: "https://www.uscis.gov/about-us/equal-employment-opportunity/equal-employment-opportunity-data-posted-pursuant-to-the-no-fear-act",
    oig: "https://www.oig.dhs.gov/",
    performance: "https://www.uscis.gov/about-us/budget-planning-and-performance",
    privacy: "https://www.uscis.gov/website-policies/privacy-and-legal-disclaimers",
  },
  media: {
    photos: [
      {
        file: "/media/uscis-ellis-island.jpg",
        small: "/media/uscis-ellis-island-sm.jpg",
        alt: "The brick and limestone Main Building on Ellis Island, with copper-domed towers and a maroon canopy, seen across the water.",
        title: "Ellis Island National Museum of Immigration",
        creator: "National Park Service",
        source: "https://commons.wikimedia.org/wiki/File:The_Ellis_Island_National_Museum_of_Immigration_(2d47faac-1dd8-b71b-0b4f-b39e54572b9b).jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/uscis-grand-canyon-ceremony.jpg",
        small: "/media/uscis-grand-canyon-ceremony-sm.jpg",
        alt: "Naturalization candidates seated on terraced rocks among pine trees at the Grand Canyon rim, facing a speaker at a wooden podium.",
        title: "Naturalization ceremony at Grand Canyon National Park, September 12, 2025",
        creator: "Grand Canyon National Park, National Park Service",
        source: "https://commons.wikimedia.org/wiki/File:2025_Naturalization_Ceremony_at_Grand_Canyon_National_Park_-_6872_(54790550635).jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
